<template>
  <div class="container">
    <section id="banner">
      <Swiper :banners="bannerImg"></Swiper>
    </section>
    <section id="intro">
      <h2>
        <p>荔虹</p>
        <span></span>
        <p>简介</p>
      </h2>
      <h3>(茘虹プロフィール)</h3>
      <div class="intro-box">
        <!-- <div class="intro-box-content" v-html="aboutObj.intro"></div> -->
        <!-- <p class="text1">
          上海荔虹锦鲤秉着“服务至上，顾客至上”
          <br />为广大客户提供满意服务。
        </p>
        <p
          class="text2"
        >上海荔虹锦鲤园隶属于上海荔宏景观设计有限公司，位于上海白鹤镇塘湾村沈家村队108号（赵重公路和纪鹤公路口），交通位置十分便利，主要以日本进口高级锦鲤鱼、养鱼器材等为主，提供大量锦鲤鱼零售和批发服务，备有鱼业工具、等产品供广大鱼友们选购。我们凭借一流的产品质量、完善的服务好评如潮。</p>
        <p class="text2">场内常备高级锦鲤鱼、养鱼器材等、供客户选购，同时为各界人士度身设计鱼池，承包造池；并提供售后饲养技术指导、鱼池维护、等一条龙服务。</p>-->
        <p class="text1" v-html="aboutObj.title"></p>
        <p class="text2" v-html="aboutObj.content"></p>
        <button @click="goLink('aboutIndex')">
          了解更多
          <i class="fa fa-angle-right"></i>
        </button>
      </div>
    </section>

    <section id="auction" v-if="haveAuction">
      <h2>
        <p>拍卖</p>
        <span></span>
        <p>中心</p>
      </h2>
      <h3>（競売センター）</h3>
      <div class="auction-box">
        <div class="auction-box-left">
          <img :src="nowObj.imgUrl" alt="auction-img" />
        </div>
        <div class="auction-box-right">
          <h2>{{ nowObj.title }}</h2>
          <p class="text1">{{ nowObj.remarks }}</p>
          <p>
            {{
              nowObj.transactionType === 1
                ? '距离结束'
                : nowObj.transactionType === 2
                ? '截止时间'
                : '距离开始'
            }}
          </p>
          <div v-if="nowObj.transactionType !== 2">
            <span>{{ hh }}</span
            >时 <span>{{ mm }}</span
            >分 <span>{{ ss }}</span
            >秒
          </div>
          <div class="item-time-box" v-else>
            <p class="text-end-time">{{ nowObj.expectEndDate }}</p>
          </div>
          <button @click="goToDetail(nowObj)">查看详情</button>
        </div>
      </div>
    </section>

    <section id="commodity">
      <h2>
        <p>商品</p>
        <span></span>
        <p>推荐</p>
      </h2>
      <h3>(商品の推薦)</h3>
      <div class="commodity-box">
        <div class="commodity-box-list clearfix">
          <div
            class="commodity-box-item"
            v-for="good in commodity"
            :key="good.id"
          >
            <div class="commodity-box-item-wrap">
              <div class="commodity-box-item-img">
                <img :src="good.imgsUrl" />
              </div>
              <div>
                <p>{{ good.name }}</p>
                <!-- <p v-html="good.details"></p> -->
                <a class="commodity-link" @click="subPay(good)">立即购买</a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <button @click="goLink('shopIndex')">
        查看更多
        <i class="fa fa-angle-right"></i>
      </button>
    </section>

    <section id="news">
      <h2>
        <p>新闻</p>
        <span></span>
        <p>动态</p>
      </h2>
      <h3>(ニュースの動き)</h3>
      <div class="news-box">
        <div class="news-box-left">
          <div
            v-for="(item, index) in news"
            :key="item.id"
            :class="
              newshover == index
                ? 'news-box-left-item active'
                : 'news-box-left-item'
            "
            @mouseenter="newsHover(index)"
            @click="goToNewsDetail(item)"
          >
            <div class="news-box-left-item-num">0{{ index + 1 }}</div>
            <div class="news-box-left-item-content">
              <p>
                <b>{{ item.title }}</b>
                <span>{{ item.createDate }}</span>
              </p>
              <p>{{ item.intro }}</p>
            </div>
          </div>
        </div>
        <div class="news-box-right">
          <div
            v-for="(img, index) in news"
            :key="img.id"
            :class="[
              newshover == index
                ? 'focuspoint item-news active'
                : 'focuspoint item-news'
            ]"
            data-focus-x="0"
            data-focus-y="0"
            data-image-w="540"
            data-image-h="405"
          >
            <img :src="img.imgUrl" />
            <!-- <img src="../../assets/img/top.jpg" alt=""> -->
          </div>
        </div>
      </div>
      <button @click="goLink('newsIndex')">
        查看更多
        <i class="fa fa-angle-right"></i>
      </button>
    </section>
  </div>
</template>

<script>
import Swiper from '../../components/swiper';
import { getNewsList } from '@/api/new';
import { recommendProduct } from '@/api/shop';
import { auctionNow } from '@/api/auction';
import { getBanner } from '@/api/home';
import { getAboutDetail } from '@/api/about';
export default {
  name: 'homeIndex',
  data() {
    return {
      bannerImg: [],
      auction: {},
      commodity: [],
      news: [],
      newshover: 0,
      current: 1,
      display: 4,
      total: 1,
      nowObj: {},
      hh: '', //时
      mm: '', //分
      ss: '', //秒
      aboutObj: {}, //简介对象
      haveAuction: false,
      ctime: null,
      ctimeRe: null
    };
  },
  components: {
    Swiper
  },
  created() {
    this.loadData();
    this.refr();
  },
  destroyed() {
    clearTimeout(this.ctime);
    clearTimeout(this.ctimeRe);
  },
  methods: {
    format(value) {
      //为了兼容ie9时间格式
      if (value) {
        var tt = value.replace(/-/g, '/');
        var time = new Date(tt);
        return time;
      } else {
        return '';
      }
    },
    setTime() {
      let type = this.nowObj.transactionType,
        time = '';
      if (type === 1) {
        time = this.nowObj.endDate
          ? this.nowObj.endDate
          : this.nowObj.expectEndDate;
      } else if (type === 0) {
        time = this.nowObj.startDate;
      }
      let numTime = (this.format(time) - new Date()) / 1000;
      this.setIntervalTime(numTime);
    },
    setIntervalTime(numTime) {
      let h = parseInt(numTime / 3600),
        m = parseInt((numTime - h * 3600) / 60),
        s = parseInt(numTime - h * 3600 - m * 60);
      this.hh = h < 10 ? '0' + h : h;
      this.mm = m < 10 ? '0' + m : m;
      this.ss = s < 10 ? '0' + s : s;
      numTime -= 1;
      if (numTime < 0) {
        clearTimeout(this.ctime);
        clearTimeout(this.ctimeRe);
        auctionNow(this);
      } else {
        this.ctime = setTimeout(() => {
          this.setIntervalTime(numTime);
        }, 1000);
      }
    },
    getStyle(obj, name) {
      if (obj.currentStyle) {
        return obj.currentStyle[name];
      } else {
        return getComputedStyle(obj, false)[name];
      }
    },
    loadData() {
      // 获取banner图片
      getBanner(this, () => {
        let bannerH =
          document.documentElement.clientHeight -
          parseFloat(
            this.getStyle(
              document.getElementsByClassName('jl-nav-header')[0],
              'height'
            )
          );
        document.getElementById('banner').style.height = bannerH + 'px';
        //console.log(bannerH);
      });
      // 获取简介
      getAboutDetail(this);
      // 获取拍卖
      clearTimeout(this.ctime);
      clearTimeout(this.ctimeRe);
      auctionNow(this);
      // 获取商品
      recommendProduct(this);
      //获取新闻动态
      getNewsList(this, () => {
        let list = this.news.map(item => {
          item.imgUrl = item.imgUrl ? item.imgUrl.split('|')[0] : '';
          item.createDate = item.createDate
            ? item.createDate.split(' ')[0]
            : '';
          return item;
        });
        this.news = list;
        this.$nextTick(() => {
          $('.focuspoint').focusPoint();
        });
      });
    },
    newsHover(index) {
      this.newshover = index;
    },
    goLink(val) {
      this.$router.push({
        name: val
      });
    },
    subPay(item) {
      this.$router.push({
        name: 'shopDetailIndex',
        query: {
          id: item.id
        }
      });
    },
    goToDetail(item) {
      this.$router.push({
        name: 'auctionView',
        query: {
          id: item.id
        }
      });
    },
    goToNewsDetail(item) {
      this.$router.push({ name: 'newsDetail', params: { id: item.id } });
    },
    //十秒刷新
    refr() {
      clearTimeout(this.ctimeRe);
      this.ctimeRe = setTimeout(() => {
        auctionNow(this);
        this.refr();
      }, 10000);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@mixin red-circle {
  width: 12px;
  height: 12px;
  display: inline-block;
  border-radius: 50%;
  margin: 0 10px;
  border: 2px solid #e50011;
}
@mixin hoverTran {
  transition: all 0.3s;
}
#banner {
  width: 100%;
  height: 800px;
}
#intro {
  width: 100%;
  text-align: center;
  padding-bottom: 79px;
  background-image: url('../../assets/img/zlc-intro-bg.jpg');
  background-size: 100% 100%;
  background-repeat: no-repeat;

  h2 {
    padding-top: 80px;
    margin-bottom: 20px;
    font-size: 54px;
    line-height: 54px;
    color: #333;
    text-align: center;
    p {
      display: inline-block;
    }
    span {
      @include red-circle;
    }
  }
  h3 {
    margin-top: 0;
    margin-bottom: 60px;
    font-size: 24px;
    // font-size: font(24);
    line-height: 24px;
    // line-height: font(24);
    color: #666;
    font-weight: 700;
  }
  .intro-box {
    max-width: 1200px;
    margin: 0 auto;
    padding-bottom: 50px;
    background-color: rgba($color: #fff, $alpha: 0.8);
    box-shadow: 0px 0px 24px rgba($color: #676767, $alpha: 0.16);
    overflow: hidden;
    .intro-box-content {
      padding: 25px 20px 0 20px;
    }
    p {
      text-align: center;
    }
    .text1 {
      font-size: 24px;
      margin: 52px auto 10px;
      color: #333;
      font-weight: bold;
      line-height: 36px;
      margin-bottom: 34px;
    }
    .text2 {
      width: 66%;
      font-size: 16px;
      line-height: 30px;
      margin: auto;
      color: #666;
      margin-bottom: 30px;
    }
    button {
      display: block;
      background-color: transparent;
      border: 2px solid #333;
      height: 58px;
      width: 255px;
      border-radius: 0;
      font-size: 18px;
      margin: 50px auto 0;
      color: #333;

      i {
        font-size: 24px;
        margin-left: 30px;
      }
    }
  }
}
#auction {
  width: 100%;
  text-align: center;
  padding-bottom: 78px;
  background-image: url('../../assets/img/zkj-home-bg.jpg.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  color: #fff;

  h2 {
    padding-top: 80px;
    margin-bottom: 20px;
    font-size: 54px;
    line-height: 54px;
    color: #fff;
    font-weight: 500;
    p {
      display: inline-block;
    }
    span {
      @include red-circle;
    }
  }
  h3 {
    margin-top: 0;
    margin-bottom: 20px;
    font-size: 24px;
    // font-size: font(24);
    line-height: 24px;
    // line-height: font(24);
    color: #ccc;
    font-weight: 700;
  }
  .auction-box {
    max-width: 1200px;
    margin: 0 auto;
    // min-height: vw(673vw);

    .auction-box-left {
      display: inline-block;
      width: 800px;
      // height: 600px;
      margin: 36px 0;
      overflow: hidden;

      img {
        display: block;
        width: 100%;
        height: 100%;
      }
    }
    .auction-box-right {
      display: inline-block;
      vertical-align: top;
      width: 394px;
      min-height: 724px;
      padding-bottom: 120px;
      background-color: rgba($color: #fff, $alpha: 0.1);
      h2 {
        font-size: 36px;
        line-height: 36px;
        margin: 120px auto 30px;
        padding: 0 73px;
      }
      .text1 {
        font-size: 14px;
        line-height: 24px;
        margin-bottom: 100px;
        text-align: center;
      }
      p:nth-child(3) {
        font-size: 18px;
        // font-size: font(18);
        // line-height: font(18);
        margin-bottom: 30px;
      }
      div {
        margin-bottom: 80px;
        font-size: 24px;

        span {
          display: inline-block;
          width: 52px;
          height: 52px;
          line-height: 52px;
          margin: 0 10px;
          background-color: #fff;
          border-radius: 50%;
          color: #333;
          font-size: 28px;
          // font-size: font(28);
        }
      }
      button {
        background-color: transparent;
        border: 1px solid #fff;
        color: #fff;
        width: 186px;
        height: 48px;
        border-radius: 0;
        font-size: 16px;
        @include hoverTran;
      }
    }
  }
}
#commodity {
  width: 100%;
  padding-bottom: 80px;
  background-color: #f8f8fb;
  text-align: center;
  h2 {
    padding-top: 80px;
    margin-bottom: 20px;
    font-size: 54px;
    line-height: 54px;
    color: #333;
    p {
      display: inline-block;
    }
    span {
      @include red-circle;
    }
  }
  h3 {
    margin-top: 0;
    margin-bottom: 60px;
    font-size: 24px;
    // font-size: font(24);
    line-height: 24px;
    // line-height: font(24);
    color: #666;
    font-weight: 700;
  }

  .commodity-box {
    max-width: 1200px;
    margin: 0 auto;
    .commodity-box-list {
      margin-left: -15px;
      margin-right: -15px;
    }

    .commodity-box-item {
      float: left;
      width: 33.33%;
      padding: 0 15px;
      .commodity-box-item-img {
        position: relative;
        // height: 506px;
        padding-bottom: 0;
        overflow: hidden;
        &::after {
          /* content: "";
          display: inline-block;
          vertical-align: middle;
          width: 0;
          height: 100%; */
        }
        img {
          /*  display: inline-block;
          vertical-align: middle;
          max-width: 100%;
          max-height: 100%; */
          display: block;
          width: 100%;
          transition: all 0.3s;
        }
      }
      .commodity-box-item-wrap {
        box-shadow: 5px 5px 15px rgba($color: #ccc, $alpha: 0.4);
        background-color: #fff;
        transition: all 0.3s;
      }

      div {
        width: 100%;
        overflow: hidden;
        padding-bottom: 30px;

        p {
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          padding: 0 28px;
        }
        p:nth-child(1) {
          font-size: 24px;
          line-height: 24px;
          color: #333;
          margin: 30px auto 20px;
        }
        p:nth-child(2) {
          font-size: 14px;
          line-height: 14px;
          color: #666;
          margin-bottom: 30px;
        }
        .commodity-link {
          display: inline-block;
          line-height: 36px;
        }
        .commodity-link,
        button {
          background-color: transparent;
          border: 1px solid #000;
          width: 128px;
          height: 36px;
          color: #333;
          border-radius: 0;
          font-size: 14px;
          margin: 0;
          @include hoverTran;
        }
      }
    }
  }
  button {
    background-color: transparent;
    border: 2px solid #000;
    width: 255px;
    height: 58px;
    color: #333;
    border-radius: 0;
    font-size: 18px;
    margin-top: 80px;
    @include hoverTran;
    i {
      font-size: 24px;
      margin-left: 30px;
    }
  }
}
#news {
  width: 100%;
  padding-bottom: 122px;
  background-color: #fff;
  text-align: center;
  h2 {
    padding-top: 80px;
    margin-bottom: 20px;
    font-size: 54px;
    line-height: 54px;
    color: #333;

    p {
      display: inline-block;
    }
    span {
      @include red-circle;
    }
  }
  h3 {
    margin-top: 0;
    margin-bottom: 60px;
    font-size: 24px;
    line-height: 24px;
    color: #666;
    font-weight: 700;
  }
  .news-box {
    max-width: 1200px;
    margin: 0 auto;
    .news-box-left {
      width: 690px;
      display: inline-block;
      vertical-align: top;
      padding-right: 35px;

      .news-box-left-item {
        cursor: pointer;
        &.active {
          background-image: url('../../assets/img/zlc-news-active-bg.png');
          background-size: 100% 100%;
          background-repeat: no-repeat;
          padding-right: 15px;
          .news-box-left-item-num {
            display: none;
          }
          .news-box-left-item-content {
            width: 610px;
            margin-left: 30px;
          }
        }
        .news-box-left-item-num {
          display: inline-block;
          vertical-align: top;
          font-size: 48px;
          // font-size: font(48);
          line-height: 115px;
          color: #666;
          // width: vw(130vw);
          margin: 0 42px;
        }
        .news-box-left-item-content {
          display: inline-block;
          width: 513px;

          p:nth-child(1) {
            font-size: 22px;
            // font-size: font(22);
            line-height: 22px;
            // line-height: font(22);
            color: #333;
            margin-top: 30px;
            margin-bottom: 20px;
            white-space: nowrap;
            text-align: left;

            b {
              text-align: left;
              width: 80%;
              text-overflow: ellipsis;
              overflow: hidden;
              font-weight: 600;
              display: inline-block;
              vertical-align: top;
            }
            span {
              font-size: 16px;
              // font-size: font(16);
              line-height: 22px;
              // line-height: font(22);
              color: #999;
              display: inline-block;
              vertical-align: top;
            }
          }
          p:nth-child(2) {
            font-size: 14px;
            // font-size: font(14);
            line-height: 14px;
            // line-height: font(14);
            text-align: left;
            color: #666;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            margin: 0;
            margin-bottom: 30px;
          }
        }
      }
    }
    .news-box-right {
      position: relative;
      display: inline-block;
      vertical-align: top;
      width: 476px;
      height: 476px;
      .item-news {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        z-index: 10;
        &.active {
          z-index: 11;
        }
      }
    }
  }
  button {
    background-color: transparent;
    border: 2px solid #000;
    width: 255px;
    height: 58px;
    color: #333;
    border-radius: 0;
    font-size: 18px;
    margin-top: 60px;

    i {
      font-size: 24px;
      margin-left: 30px;
    }
  }
}

button {
  outline: none;
  cursor: pointer;
}
#intro .intro-box button,
#commodity button,
#news button {
  position: relative;
  @include hoverTran;
  &::before {
    content: '';
    position: absolute;
    right: 64px;
    top: 50%;
    width: 12px;
    height: 12px;
    border-top: 2px solid #000;
    border-left: 2px solid #000;
    transform: rotate(135deg);
    margin-top: -5px;
  }
}

@media screen and (min-width: 1200px) {
  #intro .intro-box button:hover,
  #commodity button:hover,
  #news button:hover {
    color: #fff;
    background-color: #e50011;
    border-color: #fff;
  }
  #intro .intro-box button:hover::before,
  #commodity button:hover::before,
  #news button:hover::before {
    border-top-color: #fff;
    border-left-color: #fff;
  }
  #commodity .commodity-box .commodity-box-item div .commodity-link:hover,
  #commodity .commodity-box .commodity-box-item div button:hover,
  #auction .auction-box .auction-box-right button:hover {
    color: #e50011;
    border-color: #e50011;
  }

  #commodity
    .commodity-box
    .commodity-box-item
    .commodity-box-item-wrap:hover
    img {
    transform: scale(1.1);
  }
  #commodity .commodity-box .commodity-box-item .commodity-box-item-wrap:hover {
    box-shadow: 5px 5px 15px rgba($color: #ccc, $alpha: 1);
  }
}
</style>
